import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

const TOKEN_KEY = "struktiv_admin_token";
export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? sessionStorage.setItem(TOKEN_KEY, t) : sessionStorage.removeItem(TOKEN_KEY));

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t && config.url.startsWith("/admin")) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg?.replace(/^Value error, /, "")).filter(Boolean).join(" ");
  return String(d);
}

export const store = {
  get: (k, fallback = null) => {
    try { return JSON.parse(sessionStorage.getItem(k)) ?? fallback; } catch { return fallback; }
  },
  set: (k, v) => sessionStorage.setItem(k, JSON.stringify(v)),
};
